var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.574 5.82857C14.0172 5.85884 14.2038 6.40896 13.8704 6.70261L11.3847 8.89203C10.9656 9.26115 10.7863 9.83253 10.9193 10.3749L11.7223 13.6491C11.8305 14.0902 11.3419 14.4355 10.9623 14.1861L8.31994 12.4511C7.82012 12.1229 7.17311 12.1229 6.67329 12.4511L4.03101 14.1861C3.65133 14.4354 3.16277 14.0902 3.27095 13.6491L4.07404 10.3744C4.20696 9.83243 4.02799 9.26143 3.60946 8.89226L1.1268 6.70237C0.793766 6.40861 0.9804 5.85886 1.42345 5.82856L4.56731 5.61361C5.15007 5.57377 5.65669 5.19926 5.86569 4.65381L7.02971 1.61593C7.19376 1.1878 7.79947 1.1878 7.96351 1.61593L9.12752 4.65376C9.33653 5.19924 9.84321 5.57377 10.426 5.61357L13.574 5.82857Z",
    fill: "url(#paint0_linear)",
    stroke: "#DE00A5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 8,
    y1: 13,
    x2: 7.5,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE00A5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar5);
export default __webpack_public_path__ + "static/media/star5.d4391be1.svg";
export { ForwardRef as ReactComponent };